// extracted by mini-css-extract-plugin
module.exports = {"layout":"layout--3mjne","box":"box--22F0j","editor":"editor--1kiTZ","banner":"banner--29isf","main":"main--2BeJm","footer":"footer--2DpuQ"};